/* =============================================================
   D'Avila — Barra de progresso pros sliders Dawn (featured-collection,
   related-products, main-search). Substitui o "1 / X" por bar visual.
   ============================================================= */
(function () {
  'use strict';

  function setupSlider(component) {
    var slider = component.querySelector('.slider, .product-grid');
    var buttons = component.querySelector('.slider-buttons');
    if (!slider || !buttons) return;
    if (component.dataset.davilaProgress === '1') return;
    // Nao aplicar em galeria de produto (queremos "< 1/N >" nativo estilo Insider,
    // nao a barra de progresso usada nos carrosseis de colecoes).
    if (component.id && component.id.indexOf('GalleryViewer-') === 0) return;
    if (component.closest && component.closest('media-gallery')) return;
    component.dataset.davilaProgress = '1';

    // Cria a barra de progresso
    var progress = document.createElement('div');
    progress.className = 'davila-slider-progress';
    var fill = document.createElement('div');
    fill.className = 'davila-slider-progress__fill';
    progress.appendChild(fill);

    // Insere a barra entre o botão prev e o botão next
    // Estrutura atual: [prev] [counter] [next]
    // Resultado: [prev] [progress bar] [next]
    var counter = buttons.querySelector('.slider-counter');
    if (counter && counter.parentNode === buttons) {
      buttons.replaceChild(progress, counter);
    } else {
      var prevBtn = buttons.querySelector('.slider-button--prev');
      if (prevBtn && prevBtn.nextSibling) {
        buttons.insertBefore(progress, prevBtn.nextSibling);
      } else {
        buttons.appendChild(progress);
      }
    }

    function update() {
      var max = slider.scrollWidth - slider.clientWidth;
      var pct = max > 0 ? (slider.scrollLeft / max) * 100 : 0;
      fill.style.width = Math.min(100, Math.max(0, pct)) + '%';
    }

    slider.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    setTimeout(update, 100);
  }

  function init() {
    var components = document.querySelectorAll('slider-component');
    components.forEach(setupSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
